import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";

const initialFieldValues = {
  serviceTaskId: "",
  staffId: "",
  categoryId: "",
  serviceName: "",
  month: "",
  cycle: "",
  status: "",
  lastUpdatedDate: "",
};

export default function UpdateServiceTask({
  onClose,
  headerconfig,
  serviceTask,
  onUpdateSuccess,
}) {
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);

  useEffect(() => {
    if (serviceTask) {
      setValues({
        ...serviceTask,
        lastUpdatedDate: new Date(),
      });
    }
  }, [serviceTask]);

  const validate = () => {
    let temp = {};
    temp.status = values.status !== "" ? true : false;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
      lastUpdatedDate: new Date(),
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
    setBtnSubmit(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitClicked(true);
    if (validate()) {
      setBtnSubmit(false);

      const formData = new FormData();
      formData.append("serviceTaskId", values.serviceTaskId);
      formData.append("staffId", values.staffId);
      formData.append("categoryId", values.categoryId);
      formData.append("serviceName", values.serviceName);
      formData.append("month", values.month);
      formData.append("cycle", values.cycle);
      formData.append("status", values.status);
      formData.append("lastUpdatedDate", new Date().toISOString());

      addOrEdit(formData);
    }
  };

  const applicationAPI = () => {
    return {
      update: (formData) =>
        axios.put(config.APIACTIVATEURL + config.UPDATESERVICETASK, formData, {
          ...headerconfig,
        }),
    };
  };

  const addOrEdit = (formData) => {
    applicationAPI()
      .update(formData)
      .then((res) => {
        if (res.data.statusCode === 200) {
          handleSuccess("Record Updated");
          resetForm();
          onClose();
          onUpdateSuccess();
        } else {
          handleError(res.data.message);
          setBtnSubmit(true);
        }
      })
      .catch((err) => {
        handleError("Error in updating data");
        setBtnSubmit(true);
      });
  };

  const applyErrorClass = (field) =>
    field in errors && !errors[field] ? " form-control-danger" : "";

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update Status</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Status</label>
            <select
              className={"form-select" + applyErrorClass("status")}
              name="status"
              value={values.status}
              onChange={handleInputChange}
            >
              <option value="">Select Status</option>
              <option value="PENDING">PENDING</option>
              <option value="COMPLETED">COMPLETED</option>
            </select>
            {isSubmitClicked && !errors.status && (
              <div className="validationerror">Please select status</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" variant="primary" disabled={!btnSubmit}>
            Update
          </Button>
          <Button variant="danger" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
